/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { PrescricaoSdcDto } from 'graphql/types.generated'
import React from 'react'

import { PrescricaoSdcCheckbox } from './PrescricaoSdcCheckbox'

interface PrescricaoGroupProps {
  prescricao: PrescricaoSdcDto
  handleTogglePrescricao: (ReceitaMedicamentoSdcDto) => void
  idadeCidadaoEmAnos?: number
}

export function SdcPrescricaoGroup(props: PrescricaoGroupProps) {
  const { prescricao, handleTogglePrescricao, idadeCidadaoEmAnos = 0 } = props

  return (
    prescricao.medicamentos.length > 0 && (
      <Box>
        <VFlow vSpacing={0.5}>
          <Text fontWeight='bold'>{`Para ${prescricao.titulo}`}</Text>
          {prescricao.medicamentos.length > 1 && <Text>É recomendável escolher entre:</Text>}
          {prescricao.medicamentos.map((medicamento, index) => (
            <React.Fragment>
              <PrescricaoSdcCheckbox
                dataTestId='PrescricaoCheckbox.medicamento'
                key={index}
                prescricao={medicamento}
                handleTogglePrescricao={handleTogglePrescricao}
              />
              {medicamento.medicamentoCatmat.codigoCatMat === 'BR0268390' && idadeCidadaoEmAnos >= 13 && (
                <React.Fragment>
                  <br />
                  <Text
                    style={css`
                      margin-left: 2.25rem;
                    `}
                    variant='disabled'
                  >
                    De acordo com o peso do cidadão
                  </Text>
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
        </VFlow>
      </Box>
    )
  )
}
